module.exports = __webpack_public_path__ + "static/media/calculatoricon.fa8dba9a.png";